import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_STATUS,
  BUTTON_VARIANT,
} from "./types";

export const buttonSize = {
  [BUTTON_SIZE.XLARGE]: "h-12  px-4 rounded-8 button-md px-4",
  [BUTTON_SIZE.LARGE]: "h-10   rounded-8 button-md button-md px-3",
  [BUTTON_SIZE.MEDIUM]: "h-8  px-2 rounded-6 button-sm",
  [BUTTON_SIZE.SMALL]: "h-6  px-1 rounded-4 button-sm",
};

export const buttonColor = {
  [BUTTON_COLOR.PRIMARY]: {
    [BUTTON_VARIANT.FILL]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-brand",
        text: "text-fds-on-brand",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-brand-hover",
        text: "hover:text-fds-on-brand",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-brand-select",
        text: "active:text-fds-on-brand",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-brand-disabled",
        text: "disabled:text-fds-on-brand",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-fds-brand",
        text: "text-fds-on-brand",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.OUTLINE]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-brand",
        border: "border border-fds-brand",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-brand-hover",
        border: "border hover:border-fds-brand-hover",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-brand-light",
        text: "active:text-fds-brand-select",
        border: "border active:border-fds-brand-select",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "border disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "",
        text: "",
        border: "",
      },
    },
    [BUTTON_VARIANT.TEXT]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-brand",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-brand-light",
        text: "hover:text-fds-brand-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-brand-light-hover",
        text: "active:text-fds-brand-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "",
        text: "",
        border: "",
      },
    },
    [BUTTON_VARIANT.GHOST]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-brand-light",
        text: "text-fds-brand-hover",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-brand-light-hover",
        text: "hover:text-fds-brand-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-brand-light-select",
        text: "active:text-fds-brand-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "",
        text: "",
        border: "",
      },
    },
    [BUTTON_VARIANT.TEXT_ACTION]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-brand",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-brand-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-transparent",
        text: "active:text-fds-brand-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "",
        text: "",
        border: "",
      },
    },
  },
  [BUTTON_COLOR.SECONDARY]: {
    [BUTTON_VARIANT.FILL]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-accent",
        text: "text-fds-on-accent",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-accent-hover",
        text: "hover:text-fds-on-accent",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-accent-select",
        text: "active:text-fds-on-accent",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-fds-accent",
        text: "text-fds-on-accent",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.OUTLINE]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-accent",
        border: "border border-fds-accent",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-accent-hover",
        border: "border hover:border-fds-accent-hover",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-accent-light",
        text: "active:text-fds-accent-select",
        border: "border active:border-fds-accent-select",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "border disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-accent",
        border: "border border-fds-accent",
      },
    },
    [BUTTON_VARIANT.TEXT]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-accent",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-accent-light",
        text: "hover:text-fds-accent-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-accent-light-hover",
        text: "active:text-fds-accent-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-accent",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.GHOST]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-accent-light",
        text: "text-fds-accent-hover",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-accent-light-hover",
        text: "hover:text-fds-accent-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-accent-light-select",
        text: "active:text-fds-accent-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-fds-accent-light",
        text: "text-fds-accent-hover",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.TEXT_ACTION]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-accent",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-accent-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-transparent",
        text: "active:text-fds-accent-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-accent",
        border: "border-0",
      },
    },
  },
  [BUTTON_COLOR.DANGER]: {
    [BUTTON_VARIANT.FILL]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-danger",
        text: "text-fds-on-danger",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-danger-hover",
        text: "hover:text-fds-on-danger",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-danger-select",
        text: "active:text-fds-on-danger",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-fds-danger",
        text: "text-fds-on-danger",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.OUTLINE]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-danger",
        border: "border border-fds-danger",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-danger-hover",
        border: "border hover:border-fds-danger-hover",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-danger-light",
        text: "active:text-fds-danger-select",
        border: "border active:border-fds-danger-select",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "border disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-danger",
        border: "border border-fds-danger",
      },
    },
    [BUTTON_VARIANT.TEXT]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-danger",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-danger-light",
        text: "hover:text-fds-danger-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-danger-light-hover",
        text: "active:text-fds-danger-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-danger",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.GHOST]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-danger-light",
        text: "text-fds-danger-hover",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-danger-light-hover",
        text: "hover:text-fds-danger-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-danger-light-select",
        text: "active:text-fds-danger-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-fds-danger-light",
        text: "text-fds-danger-hover",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.TEXT_ACTION]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-danger-hover",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-danger-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-transparent",
        text: "active:text-fds-danger-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-danger-hover",
        border: "border-0",
      },
    },
  },
  [BUTTON_COLOR.SUCCESS]: {
    [BUTTON_VARIANT.FILL]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-success",
        text: "text-fds-on-success",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-success-hover",
        text: "hover:text-fds-on-success",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-success-select",
        text: "active:text-fds-on-success",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-fds-success",
        text: "text-fds-on-success",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.OUTLINE]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-success",
        border: "border border-fds-success",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-success-hover",
        border: "border hover:border-fds-success-hover",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-success-light",
        text: "active:text-fds-success-select",
        border: "border active:border-fds-success-select",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "border disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-success",
        border: "border-fds-success",
      },
    },
    [BUTTON_VARIANT.TEXT]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-success",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-success-light",
        text: "hover:text-fds-success-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-success-light-hover",
        text: "active:text-fds-success-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-success",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.GHOST]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-success-light",
        text: "text-fds-success-hover",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-success-light-hover",
        text: "hover:text-fds-success-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-success-light-select",
        text: "active:text-fds-success-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-fds-success-light",
        text: "text-fds-success-hover",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.TEXT_ACTION]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-success-hover",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-success-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-transparent",
        text: "active:text-fds-success-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-success-hover",
        border: "border-0",
      },
    },
  },
  [BUTTON_COLOR.NEUTRAL]: {
    [BUTTON_VARIANT.FILL]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-inverse-tertiary",
        text: "text-fds-on-inverse",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-inverse-secondary",
        text: "hover:text-fds-on-inverse",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-inverse-primary",
        text: "active:text-fds-on-success",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-fds-inverse-tertiary",
        text: "text-fds-on-inverse",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.OUTLINE]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-primary",
        border: "border border-fds-icon-primary",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-secondary",
        border: "border hover:border-fds-hover",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-tertiary",
        text: "active:text-fds-secondary",
        border: "border active:border-fds-info-grey",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "border disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-primary",
        border: "border border-fds-icon-primary",
      },
    },
    [BUTTON_VARIANT.TEXT]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-primary",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-secondary",
        text: "hover:text-fds-primary",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-tertiary",
        text: "active:text-fds-primary",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-primary",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.GHOST]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-secondary",
        text: "text-fds-secondary",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-secondary-hover",
        text: "hover:text-fds-secondary",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-secondary-select",
        text: "active:text-fds-secondary",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-fds-disable",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-fds-secondary",
        text: "text-fds-secondary",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.TEXT_ACTION]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-tertiary",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-secondary",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-transparent",
        text: "active:text-fds-primary",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-0",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-tertiary",
        border: "border-0",
      },
    },
  },
  [BUTTON_COLOR.WARNING]: {
    [BUTTON_VARIANT.OUTLINE]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-transparent",
        text: "text-fds-on-warning-light",
        border: "border border-fds-warning",
      },

      [BUTTON_STATUS.HOVER]: {
        bg: "",
        text: "hover:text-fds-on-warning-light",
        border: "border hover:border-fds-warning-hover",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "",
        text: "active:text-fds-on-warning",
        border: "active:border-fds-warning",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "",
        text: "disabled:text-fds-disable",
        border: "border disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "",
        text: "",
        border: "",
      },
    },
    [BUTTON_VARIANT.TEXT]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-warning",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-warning-light",
        text: "hover:text-fds-warning-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-warning-light-hover",
        text: "active:text-fds-warning-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-warning",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.GHOST]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-fds-warning-light",
        text: "text-fds-warning-hover",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-warning-light",
        text: "hover:text-fds-warning-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-warning-light-hover",
        text: "active:text-fds-warning-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-warning-hover",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.TEXT_ACTION]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-warning-hover",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-transparent",
        text: "hover:text-fds-warning-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-transparent",
        text: "active:text-fds-warning-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-warning-hover",
        border: "border-0",
      },
    },
    [BUTTON_VARIANT.FILL]: {
      [BUTTON_STATUS.DEFAULT]: {
        bg: "bg-transparent",
        text: "text-fds-warning-hover",
        border: "border-0",
      },
      [BUTTON_STATUS.HOVER]: {
        bg: "hover:bg-fds-warning-light",
        text: "hover:text-fds-warning-hover",
        border: "hover:border-0",
      },
      [BUTTON_STATUS.SELECTED]: {
        bg: "active:bg-fds-warning-light-hover",
        text: "active:text-fds-warning-select",
        border: "active:border-0",
      },
      [BUTTON_STATUS.DISABLE]: {
        bg: "disabled:bg-transparent",
        text: "disabled:text-fds-disable",
        border: "disabled:border-fds-disable",
      },
      [BUTTON_STATUS.LOADING]: {
        bg: "bg-transparent",
        text: "text-fds-warning-hover",
        border: "border-0",
      },
    },
  },
};
